// Champions gallery data.
//
// This is intentionally NOT stored in the database. Champion card images live
// in `apps/web/public/champions/<year>/` and are referenced from here. To add a
// champion: drop the card image in the right year folder and add an entry below.

export interface Champion {
  /** Full league name, matching how it appears on the Ligas (rankings) page. */
  league: string;
  /** Optional champion display name, shown as a small caption under the card. */
  champion?: string;
  /**
   * Public path to the champion card image, e.g.
   * "/champions/2025/Lel-Mai-2025.png".
   * The file must live in `apps/web/public/champions/<year>/`.
   * (Anything under `public/` is served from the site root by Vite, and from
   * the built bundle by Fastify in production.)
   *
   * Leave undefined to render the "imagem do campeão" placeholder.
   */
  image?: string;
}

export interface ChampionYear {
  year: number;
  /** Champions for this year, newest league first. */
  champions: Champion[];
}

/**
 * Latest year first; within each year, newest league first.
 * Each league has a single champion.
 */
export const championsData: ChampionYear[] = [
  {
    year: 2026,
    champions: [
      {
        league: "Liga Maio/Junho 2026",
        champion: "Felipe Missio",
        image: "/champions/2026/missio-maio-2026.png",
      },
      {
        league: "Liga Fevereiro/Março 2026",
        champion: "Daniel \"Pudim\" Alves",
        image: "/champions/2026/Pudim-Campeao.png",
      }
    ],
  },
  {
    year: 2025,
    champions: [
      {
        league: "Liga Novembro 2025",
        champion: "Vinicius Lopes",
        image: "/champions/2025/Vini-nov-2025-show.png",
      },
      {
        league: "Liga Outubro 2025",
        champion: "Rafael Vianna",
        image: "/champions/2025/Vianna-Dungeon.png",
      },
      {
        league: "Liga Setembro 2025",
        champion: "Heitor Tonon",
        image: "/champions/2025/heitor-setembro-2025.png",
      },
      {
        league: "Liga Agosto 2025",
        champion: "Felipe Missio",
        image: "/champions/2025/Missio-Ago-2025.png",
      },
      {
        league: "Liga Julho 2025",
        champion: "Leo Bacci",
        image: "/champions/2025/Lel-Jul-2025.png",
      },
      {
        league: "Liga Junho 2025",
        champion: "Felipe \"Prefeito\" Gonçalves",
        image: "/champions/2025/Prefeito-Jun-2025.png",
      },
      {
        league: "Liga Maio 2025",
        champion: "Leo Bacci",
        image: "/champions/2025/Lel-Mai-2025.png",
      },
      {
        league: "Liga Abril 2025",
        champion: "Felipe Missio",
        image: "/champions/2025/Missio-Delver.png",
      },
      {
        league: "Liga Março 2025",
        champion: "Leo Bacci",
        image: "/champions/2025/lel-the-one-ring.png",
      },
      {
        league: "Liga Fevereiro 2025",
        champion: "Pedro Paulo \"PJ\" Junior",
        image: "/champions/2025/PJ.png",
      },
      // Add older 2025 leagues below, newest first, e.g.:
      // {
      //   league: "Mont Legacy League — Abril 2025",
      //   champion: "...",
      //   image: "/champions/2025/...png",
      // },
    ],
  },
  // Add older seasons below, e.g.:
  // {
  //   year: 2024,
  //   champions: [ ... ],
  // },
];
